import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'app-generic-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './generic-button.component.html',
  styleUrl: './generic-button.component.scss',
})
export class GenericButtonComponent implements OnChanges {
  @Input() buttonText: string = 'Button';
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() disabled: boolean = false;
  @Input() btnClass: string = '';
  @Output() buttonClick = new EventEmitter<void>();

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    this.disabled = changes['disabled']?.currentValue;
  }

  handleClick() {
    this.buttonClick.emit();
  }
}
